import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';
import getClassName from 'src/common/utils/getClassName';
import s from './FilterButton.module.scss';

type Props = {
  children: ReactNode;
  classNameModifier?: string;
  handleClick: () => void;
};
const FilterButton: FC<Props> = ({
  handleClick,
  classNameModifier,
  children,
}) => (
  <button
    type="button"
    className={getClassName(s, 'root', classNames(classNameModifier))}
    onClick={handleClick}
    data-test="FilterButton"
  >
    {children}
  </button>
);

export default FilterButton;
